import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TemplateSvg = function TemplateSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 25",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M2 2.249h3.056v1.482H3.48v1.574H2zM9.222 2.249H6.444v1.482h2.778z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 2.249H11.26v20H22zm-9.26 18.518V3.731h7.778v17.036z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M2 6.693v2.778h1.481V6.693zM2 13.638V10.86h1.481v2.778zM2 15.027v2.778h1.481v-2.778zM3.481 20.768v-1.575H2v3.056h3.056v-1.482zM9.222 20.768H6.444v1.481h2.778z"
    })]
  });
};
export var Template = function Template(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: TemplateSvg
  }));
};